import { render, staticRenderFns } from "./ia_agent_editor.vue?vue&type=template&id=065ca3be&scoped=true&"
import script from "./ia_agent_editor.vue?vue&type=script&lang=ts&"
export * from "./ia_agent_editor.vue?vue&type=script&lang=ts&"
import style0 from "./ia_agent_editor.vue?vue&type=style&index=0&id=065ca3be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065ca3be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCombobox,VSpacer,VSwitch,VTextField,VTextarea})
